import React from 'react';
import PropTypes from 'prop-types';

const MemberLeaderProgram = React.memo(({ data }) => {
    const programs = Array.isArray(data) ? data : [];

    return (
        <section className="profile-program-history profile-leader-history" dir="rtl">
            <div className="profile-program-history-heading">
                <div>
                    <strong>سوابق سرپرستی</strong>
                    <span>برنامه‌هایی که این عضو مسئولیت سرپرستی آن‌ها را داشته است</span>
                </div>
                <span className="profile-program-history-count">{programs.length} برنامه</span>
            </div>

            {programs.length ? (
                <div className="profile-program-history-list">
                    {programs.map((program, index) => (
                        <article className="profile-program-card" key={program.id || `${program.programName}-${index}`}>
                            <div className="profile-program-card-heading">
                                <div className="profile-program-card-title">
                                    <span className="profile-program-index">{String(index + 1).padStart(2, '0')}</span>
                                    <strong>{program.programName || 'برنامه بدون عنوان'}</strong>
                                </div>
                                {program.programDate ? <span className="profile-program-date">{program.programDate}</span> : null}
                            </div>

                            <div className="profile-program-card-details">
                                {program.workingGroupCategoryName ? <div><small>کارگروه</small><span>{program.workingGroupCategoryName}</span></div> : null}
                                {program.numberOfMembers !== null && program.numberOfMembers !== undefined ? <div><small>تعداد شرکت‌کنندگان</small><span>{program.numberOfMembers} نفر</span></div> : null}
                                <div><small>امتیاز</small><span>{program.rate ? program.rate : 'ثبت نشده'}</span></div>
                            </div>
                        </article>
                    ))}
                </div>
            ) : <div className="profile-program-history-empty">سابقه‌ای برای نمایش وجود ندارد.</div>}
        </section>
    );
});

MemberLeaderProgram.propTypes = {
    data: PropTypes.any,
};

MemberLeaderProgram.displayName = 'MemberLeaderProgram';

export default MemberLeaderProgram;
